export default "<div class=\"card\">\r\n    <div echarts id=\"bar\" class=\"chart-bar\" [options]=\"options\"></div>\r\n</div>"